import type { AccountModel } from "@/api";
import { isInvestmentBankingDemo } from "@/libs/investmentBankingDemo";

/** Display names only: preserve the imported records and their stable IDs. */
const SOURCE_NAMES: Readonly<Record<string, string>> = {
  "8a48827da046f95401a047f197807ae7": "Microsoft 365 - Human Capital",
  "8a48827da046f95401a047e5f05c7e15": "Microsoft 365 - Private Banking",
  "8a4883a28b341a56018b3746fb710183": "Snowflake Production",
  "8a4882149ef7fd0e019ef888cbb3034c": "Dremio - Enterprise Analytics",
  "8a488138a032c87801a032ea8c57014d": "Microsoft 365 - Client Services",
  "8a4882c1a0330b5101a033904b5528f2": "Microsoft 365 - Compliance Records",
  "8a4881319ffefef601a0004e0bea691f": "Databricks - Quantitative Research",
  "8a48834e9ede5597019ede7d274202e1": "Dremio - Risk Analytics",
  "8a48834e9ede5597019ede728d1b01c0": "Dremio - Portfolio Analytics",
  "2c9180838467341101846a855246569e": "MySQL - Client Operations",
  "8a48830299cd04620199ce389d41733f": "MySQL - Branch Operations",
  "2c91808384a92f5a0184a967bced020a": "MySQL - Payments Operations",
  "8a4881b39a33a7e0019a34e487cf05fd": "Power BI - Management Reporting",
  "8a48832499c207a60199c2148f0e0005": "Databricks - Enterprise Reference Data",
  "8a4881259d75a817019d760fe8d20811": "Customer Data Platform",
  "8a48816897a1a69e0197a1e4ffe80394": "Snowflake - Regulatory Reporting",
  "8a4881169dbbccea019dbdef74e613d2": "Oracle - Financial Ledger",
  "8a4881169dbbccea019dbdef0cc613cf": "SQL Server - Treasury Reporting",
  "8a4881259d75a817019d776f2e2a39c4": "SQL Server - Securities Operations",
  "8a4883ff90b3efb60190badc778b02ea": "Oracle - Trade Settlement",
  "8a4882e79c2232a8019c22ac5b0303ed": "Power BI - Portfolio Performance",
  "8a4881a19a16b032019a1737d5a862b3": "Databricks - Operational Analytics",
  "8a48839f9a5c60a4019a5e8385384e73": "Power BI - Client Insights",
  "8a48825f955bd07701955c03ddf846e6": "Databricks - Market Risk",
  "8a48824e8ff24c55018ff285208f52b9": "Databricks - Trading Analytics",
  "8a4882869310b075019310b8d1a20007": "SQL Server - Trade Capture",
  "8a4881779b079636019b0798ba7c0006": "SQL Server - Client Servicing",
  "8a4883c89aba385c019aba4050ff0030": "Power BI - Compliance Insights",
  "8a4881d89352e15d0193534f228d0400": "SQL Server - Finance Operations",
  "2c91808280bc32f40180d108cbea0ca5": "Redshift - Enterprise Reporting",
  "8a4882888bff6511018bffe1379819ea": "Redshift - Transaction Analytics",
  "2c91808280bc32f40180d10ac3140caf": "Aurora - Client Accounts",
  "8a4882888bff6511018bffddab2619dc": "Aurora - Relationship Management",
  "2c9180827f268fd5017f2c136b4d1005": "Amazon S3 - Enterprise Data Lake",
  "2c9180827e8ffa46017e91254a7e052e": "DynamoDB - Client Interaction Records",
  "2c9180827d08bb2e017d1b2666ef1728": "Amazon EMR - Risk Processing",
};

export const sourceDisplayName = (account: AccountModel): string =>
  (isInvestmentBankingDemo() ? SOURCE_NAMES[account.id ?? ""] : undefined) ??
  account.name ??
  "";
